import React, { Component } from 'react';
import { MODELS } from '../../../constants/admin/settings';
import EditableAdminTable from '../EditableAdminTable';
import LabelConfigRow from '../../../components/tables/LabelConfigRow';
import CategoryPreview from '../../../components/admin/CategoryPreview';
import { LIVE_VIEW_TYPE, POST_VIEW_TYPE } from '../../../constants/clearance';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '../../../components/forms/Tooltip';
import Input from '../../../components/forms/Input';
import Checkbox from '../../../components/forms/Checkbox';
import { PERMISSIONS } from '../../../constants/authentication/permissions';

class CategoryDetails extends Component {
    renderHeader = () => {
        const { category, hasChanges, isFormValid, isNewCategory, onSave, onCancel, onDelete } = this.props;
        const canSave = hasChanges && isFormValid;

        return (
            <div className="ckp-category-details-header">
                <h1 className="ckp-ts-h1">Category Details</h1>
                <div className="ckp-category-details-actions">
                    {!isNewCategory && (
                        <button
                            className="ckp-buttons-text is-with-icon is-auto-width is-warning no-style is-delete"
                            onClick={onDelete}
                        >
                            <DeleteIcon color="inherit" />
                            DELETE
                        </button>
                    )}
                    <a className="ckp-admin-modal-forms-button ckp-buttons-text is-warning" onClick={onCancel}>
                        CANCEL
                    </a>
                    <button
                        className={`ckp-buttons ckp-admin-action-bar-button ${canSave ? '' : 'is-inactive'}`}
                        onClick={onSave}
                        disabled={!canSave}
                    >
                        SAVE
                    </button>
                </div>
            </div>
        );
    };

    renderForm = () => {
        const { category, onFieldChange, onVisibilityChange } = this.props;
        const isLiveViewChecked = category.visibleInViews?.includes(LIVE_VIEW_TYPE);
        const isPostViewChecked = category.visibleInViews?.includes(POST_VIEW_TYPE);

        return (
            <div>
                <CategoryPreview categories={[category]} mode="details" />

                <div className="ckp-category-details-column">
                    <div className="ckp-category-details-row">
                        <div>
                            <Input
                                type="text"
                                label="Name"
                                value={category.label || ''}
                                onChange={value => onFieldChange('label', value)}
                                errorMessage={!(category.label || '').trim() ? 'Required' : undefined}
                                showErrorMessage={!(category.label || '').trim()}
                            />
                        </div>

                        <div>
                            <Input
                                type="number"
                                label="Position"
                                value={category.position || 0}
                                onChange={value => onFieldChange('position', parseInt(value))}
                                regex={/^[0-9]+$/}
                                min="0"
                            />
                        </div>
                    </div>

                    <div>
                        <label>Visibility</label>
                        <div className="ckp-category-visibility-options">
                            <Checkbox
                                name="live-view"
                                checked={isLiveViewChecked}
                                onChange={e => onVisibilityChange(LIVE_VIEW_TYPE, e.target.checked)}
                                label="Card in Live View"
                                className="ckp-category-checkbox-label"
                            />
                            <Checkbox
                                name="post-view"
                                checked={isPostViewChecked}
                                onChange={e => onVisibilityChange(POST_VIEW_TYPE, e.target.checked)}
                                label="Card in Post Event View"
                                className="ckp-category-checkbox-label"
                            />
                            <Tooltip title="All categories are always visible in the details view when clicking an entry">
                                <div
                                    style={{ display: 'inline-block', padding: '8px', margin: '-8px', cursor: 'help' }}
                                >
                                    <Checkbox
                                        name="detail-view"
                                        checked={true}
                                        disabled={true}
                                        label="Detail View"
                                        className="ckp-category-checkbox-label"
                                    />
                                </div>
                            </Tooltip>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const {
            category,
            onAddLabel,
            onLabelChange,
            onColorChange,
            onDefaultSelectedChange,
            onBulkDeleteLabels,
            labelTableData
        } = this.props;
        const labels = labelTableData || category.labels || [];

        return (
            <div className="ckp-category-edit-view">
                {this.renderHeader()}
                {this.renderForm()}
                <EditableAdminTable
                    model={MODELS.EVENT_CLEARANCE_LABEL}
                    data={labels}
                    deletePermission={PERMISSIONS[`${MODELS.EVENT_CLEARANCE_LABEL.toUpperCase()}S_DELETE`]}
                    rowComponent={LabelConfigRow}
                    buttonAction={onAddLabel}
                    deleteAction={onBulkDeleteLabels}
                    enableNew={true}
                    enableSearch={true}
                    canOpenRows={false}
                    pagination={false}
                    scroll={true}
                    tableIndex={1}
                    onLabelChange={onLabelChange}
                    onColorChange={onColorChange}
                    onDefaultSelectedChange={onDefaultSelectedChange}
                    blockRowSelection={item => !item.editable}
                    labelRequired={true}
                />
            </div>
        );
    }
}

export default CategoryDetails;
